import React from 'react';
import { Typography, Grid, Button, makeStyles, Paper, Avatar } from '@material-ui/core';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(2),
  },
  logo: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    marginRight: theme.spacing(3),
  },
  sectionTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  infoRow: {
    marginBottom: theme.spacing(1),
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(2),
  },
  licenceImage: {
    maxWidth: '100%',
    height: 'auto',
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
  }
}));

const CompanyDetails = ({ record, onApprove, onReject }) => {
  const classes = useStyles();

  if (!record) return null;

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Avatar src={record.logo} className={classes.logo} />
        <div>
          <Typography variant="h4" component="h1">
            {record.name}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {record.catagory}
          </Typography>
        </div>
      </div>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" className={classes.sectionTitle}>Basic Information</Typography>
          <div className={classes.infoRow}><strong>Web:</strong> {record.web || 'N/A'}</div>
          <div className={classes.infoRow}><strong>Email:</strong> {record.email || 'N/A'}</div>
          <div className={classes.infoRow}><strong>Created At:</strong> {new Date(record.createdAt).toLocaleString()}</div>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" className={classes.sectionTitle}>Location</Typography>
          <div className={classes.infoRow}><strong>City:</strong> {record.city}</div>
          <div className={classes.infoRow}><strong>Sub City:</strong> {record.subCity}</div>
          <div className={classes.infoRow}><strong>Wereda:</strong> {record.wereda}</div>
          <div className={classes.infoRow}><strong>State:</strong> {record.state}</div>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" className={classes.sectionTitle}>Description</Typography>
          <Typography variant="body1">{record.description || 'No description provided.'}</Typography>
        </Grid>
        {record.licence && (
          <Grid item xs={12}>
            <Typography variant="h6" className={classes.sectionTitle}>Licence</Typography>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => window.open(record.licence, '_blank')}
                style={{ alignSelf: 'flex-start' }}
              >
                View License File (PDF/Image)
              </Button>
              {record.licence.match(/\.(jpeg|jpg|gif|png)$/) !== null && (
                <img src={record.licence} alt="Licence Preview" className={classes.licenceImage} />
              )}
            </div>
          </Grid>
        )}
      </Grid>

      {(onApprove || onReject) && (
        <div className={classes.actionButtons}>
          {onReject && (
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<AiOutlineClose />}
              onClick={() => onReject(record.Id)}
            >
              Reject
            </Button>
          )}
          {onApprove && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AiOutlineCheck />}
              onClick={() => onApprove(record.Id)}
            >
              Approve
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanyDetails;
